import * as React from "react";

// Import data from JSON files
import * as dataUserInfoEmployee from "../data.userinfo.employee.json";
import * as dataUserInfoEmployer from "../data.userinfo.employer.json";
const questions = {
  employee: dataUserInfoEmployee,
  employer: dataUserInfoEmployer
};
import "./UserInfo.css";

const _ = require("lodash");

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: "",
      questions: questions[this.props.employmentType],
      allValid: false
    };
  }

  componentDidMount() {
    //
    //  Get the company name, if given, from URL such as
    //  /tesco
    //  TO DO: Set the hosting server such that it loads this app from /subdirs
    // (is this actually possible?)
    //
    this.setState({ company: window.location.pathname.split("/").pop() });
  }

  validate = () => {
    // Run through the given questions and answers, setting a 'valid' boolean
    let allValid = true;
    let questions = this.state.questions;
    for (let name in questions) {
      let q = questions[name],
        // 'required'
        valid = questions[name].answer ? true : false;
      questions[name].valid = valid;
      if (!valid) allValid = false;
    }
    this.setState({ questions });
    this.setState({ allValid });
  };

  handleInputChange = e => {
    // console.log(e.target.name, e.target.value, this.state);
    // this.setState({
    //   [e.target.name]: e.target.value
    // });

    // Update the questions state variable with given answer
    let questions = this.state.questions;
    questions[e.target.name].answer = e.target.value;
    this.setState({ questions });

    this.validate();
  };

  parseAnswers(questions) {
    // Simplify questions state data and convert to a more useful obj array format
    let answers = [];
    for (var name in questions) {
      answers.push({
        name: name,
        answer: questions[name].answer
      });
    }
    return answers;
  }

  nextButtonClick(e) {
    e.preventDefault(); // Edge submits like a twat, even without type="submit"
    // Send answers back up to App
    this.props.userInfoSubmitted({
      company: this.state.company,
      userInfo: this.parseAnswers(this.state.questions)
    });
  }

  renderQuestions() {
    // USe the question data from JSON to create HTML
    return Object.keys(this.state.questions).map((name, i) => {
      let question = this.state.questions[name];
      return (
        <p key={i}>
          <label htmlFor={name}>{_.startCase(name)}</label>
          <select
            name={name}
            id={name}
            value={question.answer}
            onChange={this.handleInputChange}
          >
            <option value="">Please Select</option>
            {question.options.map((o, i) => (
              <option value={o} key={i}>
                {o}
              </option>
            ))}
          </select>
        </p>
      );
    });
  }

  reload() {
    location.reload();
  }

  render() {
    return (
      <div>
        <h1>The Future Workforce: How prepared are you and your business?</h1>
        <img src="/images/woman-phone.png" width="500" />
        <form>
          <small>
            Information provided in completing the Future of the Workforce quiz
            is collected using non personalised data and provided on the
            understanding that it will not be used otherwise than for the
            purpose it was supplied. We will not ask you to provide any details
            which could identify you to a third party.
          </small>
          <small>
            Issued by Unum Limited. Unum Limited is authorised by the Prudential
            Regulation Authority and regulated by the Financial Conduct
            Authority and the Prudential Regulation Authority. Registered
            Office: Milton Court, Dorking, Surrey RH4 3LZ. Registered in England
            983768
          </small>
          {this.renderQuestions()}
          <footer>
            <button onClick={() => this.reload()} className="button--back">
              Start over
            </button>

            <button
              disabled={!this.state.allValid}
              onClick={e => this.nextButtonClick(e)}
            >
              Next
            </button>
          </footer>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserInfo.jsx